<template>
  <div class="sign_pay">
    <template>
      <img style="width: 160px;height: auto;margin: 0 auto;" src="../assets/sign.png" alt="">
      <div class="title">{{ !returnUrl ? '支付中...' : '请到签署小程序查看支付结果' }}</div>
      <div v-html="html" style="height: 100px;"> </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "signPay",
  components: {},

  data() {
    return {
      returnUrl: false,
      html: ''
    }
  },
  created() {
    this.createAxios()
  },

  destroyed() {
    document.documentElement.style.fontSize = "16px";
  },

  methods: {
    createAxios() {
      const origin = location.hostname; //当前访问域名
      let requestBase = "";
      if (process.env.NODE_ENV === "development") {
        requestBase = '/signApi'
      } else {
        if (origin.indexOf("-testserver") > -1) {
          requestBase = process.env.VUE_APP_BASE_API_PROXYPAY;
        } else {
          requestBase = process.env.VUE_APP_BASE_API_PROXYPAYS;
        }
      }
      const config = {
        baseURL: requestBase,
        withCredentials: true,
        timeout: 30 * 1000, // Timeout
        headers: { 'Content-Type': 'multipart/form-data' }
      };
      this.axios = axios.create(config);
      this.getInfo()
    },
    async getInfo () {
      const data = await this.getQueryParams()
      // 吊起支付
      delete data.isH5
      this.getpay(data)
    },
    getQueryParams () {
      const params = {}
      const queryString = window.location.search.substring(1)
      const vars = queryString.split('&')
      for (const pair of vars) {
        const [key, value] = pair.split('=')
        params[decodeURIComponent(key)] = decodeURIComponent(value)
      }
      return params
    },
    async getpay (obj) {
      const formData = new FormData()
      for (const i in obj) {
        formData.append(i, obj[i])
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.axios
          .post(
              "",
              formData
          )
          .then(({data}) => {
            this.html = document.write(data)
            loading.close();
          })
          .catch((err) => {
            loading.close();
          });

      // 打开一个新窗口或新标签，并写入HTML代码
      // window.location.href = document.write(res)
    }
  }
}
</script>

<style scoped>
.sign_pay {
  padding: 100px 0;
  text-align: center;
}
.title {
    padding: 20px 0;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    color: #1778ff
}
</style>
